export default class Quantity {
	constructor() {
		var self = this;
		this.init();

		$( document.body ).on( 'updated_checkout wc_fragments_loaded updated_wc_div', function() {
			self.init();
		});
	}

	init() {
		$( '.quantity select' ).each( function() {
			var $this = $( this );

			var select2_args = $.extend({
				placeholder: $this.attr( 'data-placeholder' ) || $this.attr( 'placeholder' ) || '',
				label: $this.attr( 'data-label' ) || null,
				width: '100%',
				minimumResultsForSearch: 100
			}, {} );

			$( this )
				.on( 'select2:select', function(e) {
					$( this ).trigger( 'focus' );
					var value = e.params.data.id;
					$this.siblings('input[type="number"]').val(value).trigger('change');
				} )
				.selectWoo( select2_args );
		});
	}
}